import {getExportFetchURL} from "src/helpers/actionHelpers";

export function exportSummarizationValues(apiData) {
  window.open(getExportFetchURL(`/adv-report/sum/${apiData.dateSince}/${apiData.dateTo}`));
}

export function exportCompanyReceptionistsCash(apiData) {
  window.open(getExportFetchURL(`/adv-report/company-cash-sum/${apiData.companyId}/${apiData.dateSince}/${apiData.dateTo}`));
}
